let app, angular, Translator, splitView, Security;

module.exports = Promise.all([
    import("angular").then(dep => dep.default),
    import("utils/translator").then(dep => dep.default),
    import("utils/security").then(dep => dep.default),
    import("tap-split-view/tap-split-view").then(dep => dep.default),
    import("tap-filters/tap-filters").then(dep => dep.default),
    import("tap-directives/tap-directives").then(dep => dep.default),
    import("tap-services/storage-factory").then(dep => dep.default),
    import("angular-symfony-translation/angular-symfony-translation").then(dep => dep.default),
    import("imports-loader?angular=angular!ng-droplet").then(dep => dep.default),
    import("imports-loader?angular=angular!deprecate/ui-bootstrap").then(dep => dep.default),
    import("angulargrid").then(dep => dep.default),
    import("ngclipboard").then(dep => dep.default),
    import("bootstrap/js/collapse").then(dep => dep.default),
])
    .then(deps => {
        [angular, Translator, Security] = deps;

        app = angular.module("tapAssetManager", [
            "tapSplitView",
            "tapFilters",
            "tapDirectives",
            "tapServices",
            "boxuk.translation",
            "ngDroplet",
            "ui.bootstrap",
            "angularGrid",
            "ngclipboard",
        ]);

        return import("tap-asset-manager/require.js").then(dep => dep.default);
    })
    .then(() => {
        app.directive("assetManager", [
            "assetStorage",
            "$rootScope",
            "$http",
            "sharerTwitter",
            function(assetStorage, $rootScope, $http, sharerTwitter) {
                var self = this;

                return {
                    restrict: "E",
                    template: function(el, attr) {
                        var template =
                            '<split-view master-items="masterItems" master-template-url="/bundles/tapsite/html/split-view/master-cell.html" no-detail-topbar="true"></split-view>';

                        return template;
                    },
                    scope: {
                        program: "@",
                        assetSizeFactor: "@",
                    },
                    controller: function($scope) {
                        $scope.masterIsMenuOnly = true;

                        sharerTwitter.getShortUrlLength();

                        assetStorage.init(`/api-stateful/ai/programs/${$scope.program}/assets/`);

                        $scope.masterItems = [
                            {
                                title: "Manage",
                                detailTemplateUrl: "/bundles/tapsite/html/tap-asset-manager/manage-view.html",
                            },
                            {
                                title: "New",
                                detailTemplateUrl: "/bundles/tapsite/html/tap-asset-manager/new-view.html",
                                itemDisabled: !Security.isGranted("ROLE_CR_COMMISSION_MANAGER"),
                            },
                        ];

                        $scope.$on("splitViewDataLoaded", function() {
                            $rootScope.$broadcast("invokeMasterItemSelected", $scope.masterItems[0]);
                        });

                        $scope.$watch(
                            function() {
                                return assetStorage.get();
                            },
                            function(newValue) {
                                if (!newValue) {
                                    $scope.assets = [];

                                    return;
                                }

                                $scope.assetsCopy = [];
                                angular.copy(newValue, $scope.assetsCopy);
                                $scope.assets = newValue;
                            },
                            true,
                        );

                        $scope.$on("tapDropdownItemClicked", function(ev, item) {
                            if (typeof item.data.action === "function") item.data.action(item);
                        });

                        $scope.$watch(
                            function() {
                                return assetStorage.isRefreshing();
                            },
                            function(newValue) {
                                $scope.manageViewUpdating = newValue;
                            },
                            true,
                        );

                        $http.get("/api-stateful/ai/merge-tags/basic-affiliate-program/").success(function(tags) {
                            $scope.landingPageUrlTags = tags;
                        });
                    },
                };
            },
        ]);

        app.controller("masterCellCtrl", function() {
            "use strict";
        });

        app.controller("panelCtrl", [
            "$scope",
            "$rootScope",
            function($scope, $rootScope) {
                "use strict";

                $scope.parentOpened = false;

                $scope.$on("newPanelOpened", function() {
                    $scope.parentOpened = false;
                });

                $scope.setParentOpened = function() {
                    var wasOpen = $scope.parentOpened === true;

                    $rootScope.$broadcast("newPanelOpened");

                    if (!wasOpen) $scope.parentOpened = true;
                };
            },
        ]);

        return this;
    });
